import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AssessmentIcon from '@mui/icons-material/Assessment';

const navItems = [
  {
    label: "Users",
    to: "/users",
    icon: <PeopleIcon />,
    children: [
      {
        label: "Users list",
        to: "/users/usersList",
      },
      {
        label: "User registration",
        to: "/users/userRegistration",
      },
      {
        label: "User persmissions",
        to: "/users/userPermissions",
      },
    ],
  },
  {
    label: "Master",
    to: "/master",
    icon:  <BusinessIcon />,
    children: [
      {
        label: "Places",
        to: "/master/places",
      },
      {
        label: "Branches",
        to: "/master/branches",
      },
      {
        label: "Customers",
        to: "/master/customers",
      },
      {
        label: "Drivers",
        to: "/master/drivers",
      },
      {
        label: "Employees",
        to: "/master/employees",
      },
      {
        label: "Vehicles",
        to: "/master/vehicles",
      },
      {
        label: "Vehicle Types",
        to: "/master/vehicleTypes",
      },
      {
        label: "Suppliers",
        to: "/master/suppliers",
      },
    ],
  },
  {
    label: "Transactions",
    to: "/transactions",
    icon:  <ReceiptIcon />,
    children: [
      {
        label: "Lorry Receipts",
        to: "/transactions/lorryReceipts",
      },
      {
        label: "POD",
        to: "/transactions/lrAcknowledgement",
      },
      {
        label: "Payment Vouchers",
        to: "/transactions/paymentReceipts",
      },      
      // {
      //   label: "Payment Advice",
      //   to: "/transactions/paymentAdvice",
      // },
    ],
  },
  {
    label: "Reports",
    to: "/reports",
    icon:  <AssessmentIcon />,
    children: [
      {
        label: "MIS Report",
        to: "/reports",
      },
    ],
  },
];

export default navItems;